<section class="ProviderCard">
  @if (result) {
    <div class="search__result">
      @if (!removePCPavatar && result.picture) {
        <div class="search__result__id">
          <div class="avatar search__result__avatar">
            <img
              [src]="result.picture"
              alt="doctor image"
              data-test-id="providerCardImg"
            />
          </div>
          <p
            class="t-caption"
            [innerHTML]="result.gender | titlecase"
            data-test-id="providerGender"
          ></p>
        </div>
      }
      <div class="search__result__info u-fillRemaining">
        @for (attribute of config.attributes; track attribute; let i = $index) {
          @switch (attribute.type) {
            @case ('name') {
              <div class="search__result__name" (click)="onViewProfileClick()">
                <h5
                  class="t-bold"
                  [data-test-id]="'provider_' + i + 'FullName'"
                >
                  {{ result | fullName: true }}{{ attribute.suffix }}
                </h5>
                <icon
                  [name]="attribute.icon || 'chevron_right'"
                  [data-test-id]="'provider_' + i + 'Icon'"
                  [config]="{ type: 'link', size: 'medium' }"
                ></icon>
              </div>
            }
            @case ('specialty') {
              @if (result.primary_specialty) {
                <p
                  class="t-data"
                  [data-test-id]="'provider_' + i + 'specialty'"
                >
                  {{ result.primary_specialty }}
                </p>
              }
            }
            @case ('phone') {
              @if (result.phone) {
                <a
                  [href]="'tel: ' + result.phone"
                  class="t-data t-link search__result__phone"
                  [data-test-id]="'provider_' + i + 'PhoneNumber'"
                >
                  {{ result.phone }}
                </a>
              }
            }
            @case ('address') {
              @for (
                location of result.facility_locations;
                track location;
                let facilityIndex = $index
              ) {
                @if (location && location?.address?.state) {
                  <a
                    class="search__result__location"
                    target="_blank"
                    [data-test-id]="'provider_' + facilityIndex + 'Address'"
                    [href]="
                      getDirections(
                        location?.address?.street_name_1 +
                          ' ' +
                          location?.address?.city_name +
                          ' ' +
                          location?.address?.state +
                          ' ' +
                          location?.address?.zip_code
                      )
                    "
                  >
                    <p
                      class="search__result__address"
                      [data-test-id]="
                        'provider_' + facilityIndex + 'AddressDetail'
                      "
                    >
                      {{ location?.address?.street_name_1 }},
                      {{ location?.address?.city_name }},
                      {{ location?.address?.state }}
                      {{ location?.address?.zip_code }}
                    </p>
                    <p
                      class="t-caption t-link"
                      [data-test-id]="
                        'provider_' + facilityIndex + 'FacilityText'
                      "
                    >
                      {{ attribute.text }}
                    </p>
                  </a>
                }
              }
            }
            @case ('generic') {
              @if (!!getValue(attribute.prop)) {
                <p
                  class="t-data search__result__medical-group"
                  [innerHTML]="getFormattedAttributeValue(attribute)"
                  [data-test-id]="'provider_' + i + 'attributeValue'"
                ></p>
              }
            }
          }
        }
      </div>
      <div class="search__result__action">
        @if (result.selected === false) {
          <zip-button
            [config]="config.buttonConfig.add"
            [disabled]="isSelectDisabled"
            (zipButtonClicked)="onAddResultClick()"
            data-test-id="addProviderButton"
          >
          </zip-button>
        }
        @if (result.selected === true) {
          <zip-button
            [config]="config.buttonConfig.selected"
            (zipButtonClicked)="onRemoveResultClick()"
            data-test-id="removeProviderButton"
          >
          </zip-button>
        }
        <ul>
          @if (!!result.accepting_new_patients) {
            <li data-test-id="acceptingNewPatientListItem">
              <i class="icon" data-test-id="acceptingNewPatientIcon">check</i>
              Accepting New Patients
            </li>
          }
        </ul>
      </div>
    </div>
  }

  @if (whichWorkflow === 'facilitySearch') {
    <footer class="ProviderCard__footer">
      <zip-button
        class="ProviderCard__toggle"
        [config]="{
          level: 'text',
          content: !!showDetails ? 'Hide Details' : 'View Details',
          icon: !!showDetails ? 'chevron_up' : 'chevron_down',
          isIconRight: true,
        }"
        (zipButtonClicked)="toggleDetails()"
        data-test-id="showHideButton"
      >
      </zip-button>
    </footer>
  }

  @if (!!showDetails) {
    <section
      class="ProviderCard__details u-flex"
      [ngClass]="{ 'is-open': !!showDetails }"
    >
      <section
        [ngClass]="
          alignContent
            ? 'ProviderCard__alignedbenefits'
            : 'ProviderCard__details__section'
        "
      >
        @if (result.specialty_group) {
          <div class="ProviderCard__details__list">
            <p
              class="ProviderCard__label"
              data-test-id="providerSpecialtyLabel"
            >
              Specialties
            </p>
            @for (
              specialty of result.specialties;
              track specialty;
              let specialtyIndex = $index
            ) {
              <div class="ProviderCard__specialty">
                <p
                  class="ProviderCard__value"
                  [data-test-id]="'providerSpecialty_' + specialtyIndex"
                >
                  {{ specialty }}
                </p>
              </div>
            }
          </div>
        }
        @if (result.languages.length > 0) {
          <div class="ProviderCard__details__list">
            <p class="ProviderCard__label">Languages</p>
            @for (
              facility_location of result.facility_locations;
              track facility_location;
              let locationIndex = $index
            ) {
              @for (
                language of facility_location.languages;
                track language;
                let languageIndex = $index
              ) {
                <div class="ProviderCard__language">
                  <p
                    class="ProviderCard__value"
                    [data-test-id]="
                      'providerLanguage_' + locationIndex + '_' + languageIndex
                    "
                  >
                    {{ language?.name }}
                  </p>
                </div>
              }
            }
          </div>
        }
        <!-- <div *ngIf="result.plans.length > 0" class="ProviderCard__details__list">
        <p class="ProviderCard__label">Plans</p>
        <ng-container *ngFor="let plan of result.plans">
          <div class="ProviderCard__networkName">
            <p class="ProviderCard__value">{{ plan }}</p>
          </div>
        </ng-container>
      </div> -->
      </section>
    </section>
  }
</section>
